module.exports = __webpack_public_path__ + "img/biei.f24f05cc.png";